module.exports = __webpack_public_path__ + "static/media/Сафаров Дж..4ee7f66c.pdf";